
<template>
  <base-modal
    :title="title"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="分组名称"
          hasFeedback
        >
          <a-input
            placeholder="请输入分组名称"
            id="name"
            autocomplete="off"
            :disabled="!isEdit"
            v-decorator="['name', { rules: [{ required: true, message: '分组名称不能为空！' },{
              pattern: /^[^\s]*$/,
              message: '分组名称不能包含空格！'},{
                max: 50,
                message: '最多可输入50个字'}
            ] }]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="分组类型"
          hasFeedback
        >
          <a-select
            v-decorator="['type',
                          { rules: [{ required:true, message:'请选择分组类型！'}]}]"
            @change="handleSelectChange">
            <a-select-option v-for="item in groupTypeList" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
          <a-button type="primary" html-type="submit" style="margin-right:10px;" :loading="iconLoading">
            提交
          </a-button>
          <a-button style="margin-right:10px;" @click="cancel">
            取消
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { addGroup, editGroup, getGroup } from '@/api/group'
export default {
  name: 'AddGroupModal',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      iconLoading: false,
      form: this.$form.createForm(this, { name: 'group' }),
      visible: false,
      defaultModel: {},
      model: {

      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      groupTypeList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.getSelectInfo()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.getModelInfo(this.model)
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          this.iconLoading = true
          const params = { ...this.model, ...value }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            addGroup(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('updateList')
                this.open(false)
                this.iconLoading = false
              } else {
                this.$message.error(res.info.message)
                this.iconLoading = false
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            editGroup(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                // 改變列表的groupname
                this.$store.commit('setGroupName', params.name)
                this.$emit('updateList')
                this.open(false)
                this.iconLoading = false
              } else {
                this.$message.error(res.info.message)
                this.iconLoading = false
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      console.log(this.model)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: this.model.name,
          type: this.model.type
        })
      })
      this.infoLoading = false
    },
    handleChange () {

    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({ name: '', type: '' })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    handleSelectChange (value) {

    },
    getSelectInfo () {
      const params = {
        pCode: 'GROUP_TYPE'
      }
      getGroup(params).then(res => {
        if (res.status === 0) {
          this.groupTypeList = res.data.map(function (item) {
            return {
              value: item.code,
              label: item.name
            }
          })
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
